import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from '../../models/item.model';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  constructor(private _LanguageService:LanguageService) { }
  isRtl:boolean = true;
  ngOnInit(): void {
    this.isRtl = this._LanguageService.getCurrentLanguage() === LanguageEnum.ar;
    this._LanguageService.languageChange.subscribe((result: LanguageEnum) => {
      this.isRtl = result === LanguageEnum.ar;
    })
  }
  goBack(){
    history.back()
  }
}
